// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./reset.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./output.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  display: flex;
  flex-direction: column;
  flex: 1;
}

select {
  height: auto;
  padding: 0;
  border: unset;
  background-color: transparent !important;
}

select::before {
  border: 0;
}

.section {
  margin-top: var(--size-huge);
  padding-left: var(--size-standard);
  padding-right: var(--size-standard);
}

.home-page .section {
  margin-top: var(--section-padding-block);
}

@media (min-width: 1025px) {

.container {
    width: var(--content-width);
    max-width: var(--content-width);
    margin-left: auto;
    margin-right: auto;
}
  }

.mobile-display {
  display: flex;
}

@media (min-width: 1025px) {
  .mobile-display {
    display: none;
  }
}

.desktop-display {
  display: none;
}

@media (min-width: 1025px) {
  .desktop-display {
    display: flex;
  }
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--size-standard);
}

.font-bold {
  font-family: var(--font-bold), sans-serif;
}

.font-gray {
  color: var(--gray-color);
}

.font-warning {
  color: var(--warning-color)
}

.font-alert {
  color: var(--alert-text-color);
}

.font-green {
  color: var(--green-text-color);
}

.font-light-green {
  color: var(--bright-green);
}

.link {
  font-size: inherit;
  color: var(--brand-color)
}

.mt-standard {
  margin-top: var(--size-standard);
}

.text-align-center {
  text-align: center;
}

.z-min {
  z-index: 1;
}

.z-medium {
  z-index: 2;
}

.z-max {
  z-index: 3;
}

/* MUI select options modal */
.MuiPopover-root .MuiPaper-root {
  border-radius: var(--size-medium);
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,kCAAoC;EAApC,mCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAGE;;AADF;IAEI,2BAA2B;IAC3B,+BAA+B;IAC/B,iBAAmB;IAAnB,kBAAmB;AAEvB;EADE;;AAGF;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,iCAAiC;AACnC","sourcesContent":["@import 'reset.css';\n@import 'output.css';\n\n#root {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\nselect {\n  height: auto;\n  padding: 0;\n  border: unset;\n  background-color: transparent !important;\n}\n\nselect::before {\n  border: 0;\n}\n\n.section {\n  margin-top: var(--size-huge);\n  padding-inline: var(--size-standard);\n}\n\n.home-page .section {\n  margin-top: var(--section-padding-block);\n}\n\n.container {\n  @media (min-width: 1025px) {\n    width: var(--content-width);\n    max-width: var(--content-width);\n    margin-inline: auto;\n  }\n}\n\n.mobile-display {\n  display: flex;\n}\n\n@media (min-width: 1025px) {\n  .mobile-display {\n    display: none;\n  }\n}\n\n.desktop-display {\n  display: none;\n}\n\n@media (min-width: 1025px) {\n  .desktop-display {\n    display: flex;\n  }\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-standard);\n}\n\n.font-bold {\n  font-family: var(--font-bold), sans-serif;\n}\n\n.font-gray {\n  color: var(--gray-color);\n}\n\n.font-warning {\n  color: var(--warning-color)\n}\n\n.font-alert {\n  color: var(--alert-text-color);\n}\n\n.font-green {\n  color: var(--green-text-color);\n}\n\n.font-light-green {\n  color: var(--bright-green);\n}\n\n.link {\n  font-size: inherit;\n  color: var(--brand-color)\n}\n\n.mt-standard {\n  margin-top: var(--size-standard);\n}\n\n.text-align-center {\n  text-align: center;\n}\n\n.z-min {\n  z-index: 1;\n}\n\n.z-medium {\n  z-index: 2;\n}\n\n.z-max {\n  z-index: 3;\n}\n\n/* MUI select options modal */\n.MuiPopover-root .MuiPaper-root {\n  border-radius: var(--size-medium);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
